const isProduction = process.env.NODE_ENV === 'production';
const noop = () => undefined;
export const logger = {
    log: isProduction ? noop : console.info,
    warn: isProduction ? noop : console.warn,
    error: console.error
};
